import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbButton } from '../../types/pbBlocks';
import { getAdvanced, getButtonsAppearance, parseStyleString } from '../utils';

export type ButtonType = ContentTypeObject & PbButton;

/**
 * Aggregates the configuration of a button element.
 * @param node
 */
export function buttonsConfigAggregator(node: CustomHtmlElement): ButtonType {
    const style = parseStyleString(node.attributes.style);

    return {
        ...getAdvanced(node, style),
        appearance: getButtonsAppearance(node.attributes['data-appearance']),
        isSameWidth: node.attributes['data-same-width'] === 'true',
        uniqueID: node.attributes['data-pb-style'],
    };
}
